import {h} from 'preact';
import cx from 'classnames';

const RatingStars = ( {
                          className = '',
                          rating = 0,
                          showDataAsLabel,
                          color = 'brand'
                      } ) => {

    const ratingClassName = cx(
        'rating-stars',
        className,
        `text-${color}`,
        {'rating-stars--labeled': showDataAsLabel}
    );

    const ratingDisplay = Number( rating ).toFixed( 1 );

    return (
        <div className={ratingClassName}
             data-rating={ratingDisplay} data-testid="rating-stars">
            <i className="rating-stars--icon"/>
            <i className="rating-stars--icon"/>
            <i className="rating-stars--icon"/>
            <i className="rating-stars--icon"/>
            <i className="rating-stars--icon"/>
        </div>
    );
};

export default RatingStars;